import App from 'app/app.js';

/*jslint regexp: true */

function ValidationService() {
  var constraints = {
    email: {
      presence: true,
      email: true
    }
  };

  validate.validators.email.PATTERN =
    /^(?:[a-z0-9!#$*+=?^_`|~-]+(?:\.[a-z0-9!#$*+/=?^_`|~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])+|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

  this.validate = function (validations) {
    return R.map(
      function (validation) {
        var obj = {
          code: validation.code,
          params: validation.getParams ? validation.getParams(validation.field) : undefined
        };
        return obj;
      },
      R.filter(function (validation) {
        return validation.field ? validation.field.$error[validation.validation] : undefined;
      })(validations)
    );
  };

  this.validateSelectionTemplate = function (validations) {
    return R.map(
      function (validation) {
        return {
          msg: validation.msg,
          templateName: validation.templateName,
          fieldName: validation.fieldName
        };
      },
      R.filter(function (validation) {
        if (validation.field && validation.field.$invalid) {
          return validation.field.$error[validation.validation];
        }
      })(validations)
    );
  };

  this.validateInputLength = function (inputObj, minLength, maxLength) {
    var returnVal = false;
    if (inputObj.$modelValue) {
      var hasMaxLength = inputObj.$modelValue.length ? inputObj.$modelValue.length <= maxLength : true;
      inputObj.$setValidity('maxlength', hasMaxLength);

      var hasMinLength = inputObj.$modelValue.length ? inputObj.$modelValue.length >= minLength : true;
      inputObj.$setValidity('minlength', hasMinLength);
      returnVal = hasMinLength && hasMaxLength;

      inputObj.$setValidity('required', returnVal);
      inputObj.$setValidity('hasValue', true);
    } else if (minLength > 0) {
      inputObj.$setValidity('required', false);
      inputObj.$setValidity('hasValue', false);
    } else {
      returnVal = true;
    }
    return returnVal;
  };

  this.validateInputValue = function (inputObj, invalidValueToCheck) {
    var rv = false;
    if (inputObj.$viewValue) {
      rv = inputObj.$viewValue === invalidValueToCheck;
      inputObj.$setValidity('required', !rv);
    }
    return rv;
  };

  // For more information on validation: https://lifetouchlnss.atlassian.net/wiki/spaces/MYC/pages/1169522741/Email+Validation
  this.isValidEmailFormat = function (email) {
    var validationErrors = validate({ email: email }, constraints);
    return !validationErrors || validationErrors.length === 0;
  };

  this.validateEmail = function (inputObj, minLength, maxLength) {
    this.validateInputLength(inputObj, minLength, maxLength);

    var isValid = this.isValidEmailFormat(inputObj.$modelValue);

    if (inputObj.$modelValue) {
      inputObj.$setValidity('required', isValid);
      inputObj.$setValidity('emailFormat', isValid);
    }
  };

  this.validateStudentId = function (inputObj, minLength, maxLength) {
    const validLength = this.validateInputLength(inputObj, minLength, maxLength);
    const ALL_ZEROS_REGEXP = /^0+$/;
    const ALL_HYPHENS_REGEXP = /^-+$/;
    const SPECIAL_CHAR_REGEXP = /[^a-zA-Z0-9-]/;

    const value = inputObj.$modelValue;
    const isInValidId =
      ALL_ZEROS_REGEXP.test(value) || ALL_HYPHENS_REGEXP.test(value) || SPECIAL_CHAR_REGEXP.test(value);

    return validLength && !isInValidId;
  };

  this.validatePasswordLength = function (inputValue) {
    var PASSWORD_LENGTH_REGEXP = /^\S{8,20}$/;

    if (inputValue) {
      var validLength = PASSWORD_LENGTH_REGEXP.test(inputValue);
      return validLength;
    }
    return false;
  };

  this.validatePassword = function (inputValue) {
    var PASSWORD_STRENGTH_REGEXP =
      /^(?=.*?\d)(?=.*[@#\[\]{}\(\)<>\\$&!|.\^~`*:;,?\/+="\'_%\-])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d@#\[\]{}\(\)<>\\$&!|.\^~`*:;,?\/+="\'_%\-]/;

    if (inputValue) {
      var valid = PASSWORD_STRENGTH_REGEXP.test(inputValue) && this.validatePasswordLength(inputValue);
      return valid;
    }
    return false;
  };

  this.validatePasswordIdentity = function (inputObj, min, max) {
    var WHITE_SPACE_REGEXP = /\s/;
    var minLength = min === undefined ? 6 : min;
    var maxLength = max === undefined ? 99 : max;
    this.validateInputLength(inputObj, minLength, maxLength);
    if (inputObj.$modelValue) {
      var matches = !WHITE_SPACE_REGEXP.test(inputObj.$modelValue);
      inputObj.$setValidity('required', matches);
      inputObj.$setValidity('passwordFormat', matches);
    }
  };

  this.validateConfirmationMatch = function (inputObj, confirmationInputObj) {
    var value = inputObj.$modelValue;
    var confirmationValue = confirmationInputObj.$modelValue;
    if (value && confirmationValue) {
      var matches = value === confirmationValue;
      confirmationInputObj.$setValidity('required', matches);
      confirmationInputObj.$setValidity('confirmMismatch', matches);
    }
  };

  this.validateCustAddress = function (inputObj, minLength, maxLength) {
    var returnVal = false;
    var isInputEmpty = inputObj.$isEmpty(inputObj.$viewValue);
    if (!!isInputEmpty) {
      returnVal = true;
      inputObj.$setValidity('required', returnVal);
    } else {
      returnVal = this.validateInputLength(inputObj, minLength, maxLength);
    }
    return returnVal;
  };

  this.resetErrors = function (fieldObj) {
    if (fieldObj && typeof fieldObj === 'object' && fieldObj.$setValidity) {
      fieldObj.$error = {};
      fieldObj.$setValidity('hasValue', true);
      fieldObj.$setValidity('required', true);
    }
  };
}

App.service('ValidationService', [ValidationService]);
